import { useLocation } from "react-router-dom";

export const useAdminView = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin");
};
